import './steps.scss';
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import stepsActions from 'actions/stepsActions';
import PropTypes from 'prop-types';

const StepsContentComponent = ({ immStepsState }) => {
    const getSteps = () => {
        return immStepsState.get('steps');
    };

    const getCurrentStep = () => {
        return immStepsState.get('currentStep');
    };

    const showStep = () => {
        const steps = getSteps();
        const currentIndex = getCurrentStep();
        const $step = steps.get(currentIndex).get('component');
        const step = <$step />;

        return step;
    };

    return <div className="steps">{showStep()}</div>;
};

StepsContentComponent.propTypes = {
    immStepsState: PropTypes.object.isRequired,
};

export const StepsContent = connect(
    state => ({
        immStepsState: state.steps,
    }),
    dispatch => ({
        actions: bindActionCreators(stepsActions, dispatch),
    })
)(StepsContentComponent);
